import React, { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { DataTable } from "../../components";
import Tick from "../../icons/tick.svg";
import Cross from "../../icons/cross.svg";
import { getAllConsultores, suppsNoDocs, validateNoDocSuppAlert } from "../../services";
import {
  daysDiff,
  formatoFechasEs,
} from "../../functions/funciones";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import FiltrosAlertasProv from "../../components/filtros/filtrosAlertasProv";
import { FaCheck } from "react-icons/fa";
import { UsuarioContext } from '../../providers/userContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../functions/parametrosURL/funcionesParamsURL';


const NoDocumentsAlert = ({ valorTab }) => {
  const { t } = useTranslation('common');

  const user = useContext(UsuarioContext)
  // const [Consultores, setConsultores] = useState([]);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();

  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [validating, setValidating] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });


  // useEffect(() => {
  //   // fetchData();
  //   getAllConsultores().then((res) => {
  //     setConsultores(res);
  //   });
  // }, [recargar, validating]);

  const [primeraCarga, setPrimeraCarga] = useState(true);

  const navigate = useNavigate();
  const refControladorAborto = useRef(null);

  const clearFilters = () => {
    if (user.rol === "CONSUL" && primeraCarga) {
      setBusqueda({
        ...busqueda,
        consul_id: user.id
      });
    }
    else {
      setBusqueda({});
    }


  }

  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {


    orderBy = orderBy || filtroOrder.ordenadoPor || 'ultimaReclamacion';
    order = order || filtroOrder.orden || 'ASC';

    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
        filtros.consul_id = user.id
      } else if (filtros.consul_id === 0) {
        delete filtros.consul_id
      }
      setPrimeraCarga(false);
    }


    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, valorTab);

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
      signal: nuevoControladorAborto.signal,
    };

    try {
      setLoading(true);
      const response1 = await suppsNoDocs(payload);
      const { meta, data } = response1;

      if (refControladorAborto.current === nuevoControladorAborto) {
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error?.name === 'AbortError' || error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
        if (refControladorAborto.current === nuevoControladorAborto) {
          setLoading(false);
        }
        return;
      }
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  const formatData = (data) => {

    return data.map((row, i) => ({
      proveedor_id: row.id,
      razonSocial: row.razonSocial,
      esCreatedAt: !row.ultimaReclamacion,
      ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      //ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      nif: row.nif,
      planificacionPreventiva: row.noProcede ? 'No procede' : !row.docssupps?.find((d) => d.tipoDoc === 4)?.fechaCaducidad || '',
      evaluacionRiesgos: !row.docssupps?.find((d) => d.tipoDoc === 5)?.validado === true,
      // vigilancia: row.noProcede ? 'No procede' : row.docssupps?.find((d) => d.tipoDoc === 7)?.fechaCaducidad || '',
      rlc: row.noProcede ? 'No procede' : row.docssupps?.find((d) => d.tipoDoc === 9)?.fechaCaducidad || '',
      rlcNoProcede: row.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede || false,
      rnt: row.noProcede ? 'No procede' : row.docssupps?.find((d) => d.tipoDoc === 8)?.fechaCaducidad || '',
      rntNoProcede: row.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede || false,
      listadoTrabajadores: row.noProcede ? 'No procede' : row.docssupps?.find((d) => d.tipoDoc === 10)?.validado === true,
      docTrabajadores: row.docTrabajadores || false,
      certificado: row.docssupps?.find((d) => d.tipoDoc === 6)?.fechaCaducidad || '',
      justificante: row.noProcede ? 'No procede' : row.docssupps?.find((d) => d.tipoDoc === 3)?.fechaCaducidad || '',
      seguro: row.docssupps?.find((d) => d.tipoDoc === 2)?.fechaCaducidad || '',
      validar: row.id
    }));
  };

  const proveedoresRows = [

    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.supplier'),
      overrideFunc: (data, row) => <Link to={"/proveedores/" + row.nif}>{data}</Link>
    },
    {
      id: "ultimaReclamacion",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.lastClaim'),
      overrideFunc: (data, row) => <span style={{color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span>
      // overrideFunc: (data, row) => <span style={{ color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black' }}>{formatoFechasEs(data)}</span>
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.nif'),
    },
    {
      id: "seguro",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rc'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data) => '-',
    },
    {
      id: "justificante",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.preventiveMode'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data) => data === "No procede" ? t('suppliers.columns.notApplicable') : '-',
    },
    {
      id: "evaluacionRiesgos",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.riskEvaluation'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data) => <img style={{ width: "20px" }} src={data ? Cross : Tick} alt="vacio" />,
    },
    {
      id: "planificacionPreventiva",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.preventivePlanning'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data) => data === "No procede" ? t('suppliers.columns.notApplicable') : '-',
    },
    {
      id: "listadoTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.workersList'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data) => data === "No procede" ? t('suppliers.columns.notApplicable') : '-',
    },
    {
      id: "rlc",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rlc'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data) => data === "No procede" ? t('suppliers.columns.notApplicable') : '-',
    },
    {
      id: "rnt",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rnt'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data) => data === "No procede" ? t('suppliers.columns.notApplicable') : '-',
    },
    {
      id: "certificado",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.socialSecurityCert'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: () => '-',
    },
    // {
    //   id: "vigilancia",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Vigilancia salud",
    //   noObjeto: true,
    //   overrideFunc: (data) => data === "No procede" ? data : data ? <span style={{ color: daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>{formatoFechasEs(data)}</span> : '-',
    // },
    {
      id: "docTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.workersDocs'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => row.planificacionPreventiva === "No procede" ? t('suppliers.columns.notApplicable') : <img style={{ width: "20px" }} src={data ? Tick : Cross} alt={data ? "completo" : "incompleto"} />,
    },
    {
      id: "validar",
      numeric: false,
      disablePadding: false,
      noObjeto: true,
      label: t('suppliers.columns.performed'),
      overrideFunc: (data, row) => (
        <>
          <Button style={{ background: validating ? '#7bc977' : 'green', color: 'white', minWidth: '5px' }} onClick={() => { handleCheck(data) }} disabled={validating}><FaCheck /></Button>
        </>
      )
    },
  ];

  const handleCallback = () => {
    setRecargar(!recargar);
  };

  const handleCheck = async (id) => {
    validarAlerta(id).then((resultado) => {
      handleCallback(resultado)
    })
  }

  const validarAlerta = async (id) => {
    return new Promise(async (resolve, reject) => {
      setValidating(true);
      try {
        const toastInfo = toast.info(t('suppliers.messages.validating'), { autoClose: false });
        await validateNoDocSuppAlert(id).then(res => {
          toast.update(toastInfo, {
            render: t('suppliers.messages.alertValidated'),
            type: toast.TYPE.SUCCESS,
            autoClose: true,
          });
          // setRecargar(true);
          setLoading(true);
          fetchData();
          resolve(true);
        }).catch((error) => {
          toast.update(toastInfo, {
            render: t('suppliers.messages.alertValidationError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
          reject(error)
        })
      } catch (error) {
        console.error(error);
        reject(error)
        toast.error(t('suppliers.messages.alertValidationErrorShort'));
      } finally {
        setValidating(false);
      }
    })
  }

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  }

  useEffect(() => {
    return () => {
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
    };
  }, []);

  return (
    <>
      <div className="listPage">
        <div className="gridCard">
          <div className="tableContainer">
            <FiltrosAlertasProv onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    meta={data.meta}
                    filtros={busqueda}
                    busquedaActiva={busquedaActiva}
                    setBusquedaActiva={setBusquedaActiva}
                    mensaje={t('suppliers.messages.noSuppliers')}
                    segundaCol={true}
                    enumerate={true}
                    recargar={recargar}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table thead th {
          text-align: center;
        }
      `}</style>
    </>
  );
}

export default NoDocumentsAlert;